import { render, staticRenderFns } from "./Jewel06_Nico.vue?vue&type=template&id=6d910a01&scoped=true&"
import script from "./Jewel06_Nico.vue?vue&type=script&lang=js&"
export * from "./Jewel06_Nico.vue?vue&type=script&lang=js&"
import style0 from "./Jewel06_Nico.vue?vue&type=style&index=0&id=6d910a01&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d910a01",
  null
  
)

export default component.exports